import React from "react";
import { PageHeader, Loader } from "@/components/shared";
import { AviatorStage } from "@/components/aviator/AviatorStage";
import { BetPanel } from "@/components/aviator/BetPanel";
import { AviatorTabs } from "@/components/aviator/AviatorTabs";
import { useAviator } from "@/components/aviator/useAviator";
import { fmtPKT } from "@/components/aviator/verify";

export default function Aviator() {
  const { state, load, multiplier, elapsed, countdown } = useAviator();
  if (!state) return <Loader />;
  const s = state.schedule;
  const hours = s.open_time === s.close_time ? "All day" : `${s.open_time} – ${s.close_time} PKT`;
  const refreshKey = `${state.round?.id}-${state.round?.status}-${state.my_bet?.status}`;
  return (
    <div>
      <PageHeader title="Aviator" subtitle="Join during the countdown and cash out before the plane flies away." />
      <div className="flex gap-2 overflow-x-auto pb-3 mb-3" data-testid="aviator-recent">
        {state.recent.map((r) => (
          <span key={r.round_no} className={`shrink-0 text-xs font-bold px-3 py-1 rounded-full border ${r.crash_point >= 2 ? "border-emerald-500/40 text-emerald-400 bg-emerald-500/10" : "border-red-500/40 text-red-400 bg-red-500/10"}`}>
            {r.crash_point.toFixed(2)}x
          </span>
        ))}
      </div>
      <div className="grid lg:grid-cols-3 gap-6 items-start">
        <div className="lg:col-span-2"><AviatorStage state={state} multiplier={multiplier} elapsed={elapsed} countdown={countdown} /></div>
        <div className="space-y-4">
          <BetPanel state={state} multiplier={multiplier} reload={load} />
          <div className="ec-card p-5 text-xs text-gray-400 space-y-1" data-testid="aviator-schedule">
            <p><span className="text-gray-500">Daily hours:</span> <span className="text-white">{hours}</span></p>
            {(s.start_date || s.end_date) && <p><span className="text-gray-500">Dates:</span> <span className="text-white">{s.start_date || "—"} → {s.end_date || "—"}</span></p>}
            {s.postponed_until && <p className="text-amber-400" data-testid="aviator-postponed">Postponed until {fmtPKT(s.postponed_until)}</p>}
          </div>
        </div>
      </div>
      <div className="mt-6"><AviatorTabs refreshKey={refreshKey} /></div>
    </div>
  );
}
